<app-alert></app-alert>
<app-loader></app-loader>
<router-outlet></router-outlet>

<app-drawer
  *ngIf="isDrawerOpen"
  [headerTitle]="'Confirm rejection'"
  (closeButtonClicked)="closeDrawer($event)"
  [formInvalid]="rejectOrderForm.invalid"
  (handleSubmit)="submitForm()"
>
  <div drawerBody>
    <form [formGroup]="rejectOrderForm">
      <div class="form-group mt-3">
        <label for="reason" class="f-14 lh-20 fw-400">
          Please select a reason for rejecting the order.
        </label>

        <div
          role="listbox"
          aria-orientation="vertical"
          aria-labelledby="order-rejection-options"
          aria-roledescription="order-rejection-options"
        >
          <ul>
            <li
              *ngFor="let option of rejectionReasons"
              role="option"
              class="mt-2"
            >
              <label
                [for]="option.label"
                (click)="handleReasonCollection(option)"
              >
                <input
                  type="radio"
                  class="check-custom"
                  [name]="option.label"
                  [value]="option.label"
                  [checked]="option.label === selectedOption"
                />
                <span class="check-toggle"></span>
                {{ option?.label }}
              </label>
            </li>
          </ul>
        </div>

        <textarea
          *ngIf="showInput"
          #reason
          (blur)="updateFormValue(reason.value)"
          class="auth-text-area"
          id=""
          cols="30"
          rows="10"
        ></textarea>
      </div>
    </form>
  </div>
</app-drawer>

<app-menu-drawer
  *ngIf="isMenuDrawerOpen"
  (closeButtonClicked)="closeMenuDrawer($event)"
>
  <section drawerBody>
    <nav class="navbar d-flex flex-column main-nav mt-3">
      <p class="mb-2 f-14 fw-400 text__grey-500">Orders</p>
      <li class="nav-item w-100" (click)="closeMenuDrawer($event)">
        <a
          routerLinkActive="active"
          routerLink="/live-orders"
          class="nav-link pointer"
        >
          <img
            class="active"
            src="/assets/icons/live-orders-active.svg"
            alt=""
          />
          <img class="inactive" src="/assets/icons/live-orders.svg" alt="" />
          <span class="nav-text">Live orders</span>
        </a>
      </li>
      <li class="nav-item" (click)="closeMenuDrawer($event)">
        <a
          routerLinkActive="active"
          routerLink="/completed-orders"
          class="nav-link pointer"
        >
          <img
            class="active"
            src="/assets/icons/completed-orders-active.svg"
            alt=""
          />
          <img
            class="inactive"
            src="/assets/icons/completed-orders.svg"
            alt=""
          />
          <span class="nav-text">Completed orders</span>
        </a>
      </li>
    </nav>

    <nav class="navbar d-flex flex-column main-nav mt-3">
      <p class="mb-2 f-14 fw-400 text__grey-500">Account</p>
      <li class="nav-item w-100" (click)="closeMenuDrawer($event)">
        <a
          routerLinkActive="active"
          routerLink="/account-settings"
          class="nav-link pointer"
        >
          <img class="active" src="/assets/icons/account-settings.svg" alt="" />
          <img
            class="inactive"
            src="/assets/icons/account-settings.svg"
            alt=""
          />
          <span class="nav-text">Account settings</span>
        </a>
      </li>
      <li class="nav-item w-100" (click)="closeMenuDrawer($event)">
        <a routerLinkActive="active" class="nav-link pointer">
          <img class="active" src="/assets/icons/support.svg" alt="" />
          <img class="inactive" src="/assets/icons/support.svg" alt="" />
          <span class="nav-text">Support</span>
        </a>
      </li>
      <li class="nav-item w-100" (click)="logout()">
        <a class="nav-link pointer">
          <img class="active" src="/assets/icons/logout.svg" alt="" />
          <img class="inactive" src="/assets/icons/logout.svg" alt="" />
          <span class="nav-text">Log out</span>
        </a>
      </li>
      <li class="nav-item w-100 ml-2">
        <span class="text-light f-14">Switch online status</span> <br />
        <mat-slide-toggle
          [checked]="isOnline === true"
          (change)="changeOnlineStatus($event.checked)"
          class="f-14 text-light mt-2"
        >
          {{ isOnline ? 'Online' : 'Offline' }}
        </mat-slide-toggle>
      </li>
    </nav>
  </section>
  <section drawerFooter>
    <div class="footer-card text-light" *ngIf="credentials">
      <!-- Image should be here -->
      <p class="fw-600 lh-24 mb-2">
        {{ credentials?.restaurant.name }}
      </p>

      <p class="f-14 lh-16 fw-400">
        <span>
          <img src="/assets/icons/location.svg" alt="address" loading="lazy" />
        </span>
        {{ createAddress(credentials?.restaurant?.address) }}
      </p>
    </div>
  </section>
</app-menu-drawer>
